<template>
  <div class="main-container">
    <ProgressBar class="progressbar" />
    <div class="container-area-personale">
      <div class="header">
        <h2 class="title">AREA PERSONALE</h2>
      </div>
      <div class="studio-info-personale">
        <template v-if="!isLoading && studio && utente">
          <div class="utente-dashboard">
            <!-- Modifica del titolo utente: Nome Cognome + email piccola, o messaggio evidenziato se assenti -->
            <div class="utente-title-wrapper">
              <i class="fa-solid fa-user utente-icon"></i>
              <div class="utente-info">
                <h3
                  v-if="utente.first_name && utente.last_name"
                  class="utente-name"
                >
                  {{ utente.first_name }} {{ utente.last_name }}
                </h3>
                <h3
                  v-else
                  class="utente-name todo-highlight"
                  @click="apriModificaNome"
                  style="cursor: pointer"
                >
                  <i class="fa-solid fa-plus"></i>
                  Aggiungi Nome e Cognome
                </h3>
                <p class="utente-email">{{ utente.email }}</p>
              </div>
            </div>

            <div class="utente-stats">
              <div class="stat-card">
                <span class="stat-label">Prospetti Paghe convertiti</span>
                <span class="stat-value">{{
                  utente.conversioni_effettuate_prospetti
                }}</span>
              </div>
              <div class="stat-card">
                <span class="stat-label">Modelli F24 convertiti</span>
                <span class="stat-value">{{
                  utente.conversioni_effettuate_f24
                }}</span>
              </div>
              <div class="stat-card">
                <span class="stat-label">Bilanci Analitici convertiti</span>
                <span class="stat-value">{{
                  utente.conversioni_effettuate_bilanci
                }}</span>
              </div>
              <div class="stat-card">
                <span class="stat-label">Data di registrazione</span>
                <span class="stat-value">{{
                  formatDate(utente.data_registrazione)
                }}</span>
              </div>
            </div>

            <!-- Sezione Modifica Dati Personali pulita -->
            <div class="modifica-dati-section">
              <button
                @click="mostraModificaDati = !mostraModificaDati"
                class="btn-modifica-dati"
                :class="{ active: mostraModificaDati }"
              >
                <i class="fa-solid fa-edit"></i>
                Modifica Dati Personali
                <span class="arrow" :class="{ open: mostraModificaDati }"
                  >▼</span
                >
              </button>

              <transition name="fade-slide">
                <div v-if="mostraModificaDati" class="sub-actions">
                  <!-- Toggle Modifica Profilo -->
                  <div class="action-section">
                    <button
                      @click="mostraFormProfilo = !mostraFormProfilo"
                      class="btn-toggle"
                      :class="{ active: mostraFormProfilo }"
                    >
                      <i class="fa-solid fa-user-edit"></i>
                      Modifica Nome e Cognome
                      <span class="arrow" :class="{ open: mostraFormProfilo }"
                        >▼</span
                      >
                    </button>
                    <transition name="fade-slide">
                      <div v-if="mostraFormProfilo" class="form-container">
                        <form
                          @submit.prevent="updateProfile"
                          class="action-form"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="form.firstName"
                              placeholder="Nome"
                              required
                              class="action-input"
                            />
                          </div>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="form.lastName"
                              placeholder="Cognome"
                              required
                              class="action-input"
                            />
                          </div>
                          <div class="form-actions">
                            <button
                              type="submit"
                              class="btn-confirm"
                              :disabled="isUpdatingProfile"
                            >
                              <span v-if="isUpdatingProfile"
                                >Caricamento...</span
                              >
                              <span v-else>Conferma</span>
                            </button>
                            <button
                              type="button"
                              @click="mostraFormProfilo = false"
                              class="btn-cancel"
                            >
                              Annulla
                            </button>
                          </div>
                        </form>
                        <p v-if="profileMessage" :class="profileMessageType">
                          {{ profileMessage }}
                        </p>
                      </div>
                    </transition>
                  </div>
                  <!-- Toggle Cambio Password -->
                  <div class="action-section">
                    <button
                      @click="mostraFormPassword = !mostraFormPassword"
                      class="btn-toggle"
                      :class="{ active: mostraFormPassword }"
                    >
                      <i class="fa-solid fa-key"></i>
                      Cambia Password
                      <span class="arrow" :class="{ open: mostraFormPassword }"
                        >▼</span
                      >
                    </button>
                    <transition name="fade-slide">
                      <div v-if="mostraFormPassword" class="form-container">
                        <form
                          v-if="canChangePasswordInMyStudio"
                          @submit.prevent="cambiaPassword"
                          class="action-form"
                        >
                          <div class="input-group">
                            <input
                              type="password"
                              v-model="form.vecchiaPassword"
                              placeholder="Vecchia password"
                              required
                              class="action-input"
                            />
                          </div>
                          <div class="input-group">
                            <input
                              type="password"
                              v-model="form.nuovaPassword"
                              placeholder="Nuova password"
                              required
                              minlength="6"
                              class="action-input"
                            />
                          </div>
                          <div class="input-group">
                            <input
                              type="password"
                              v-model="form.confermaPassword"
                              placeholder="Conferma nuova password"
                              required
                              minlength="6"
                              class="action-input"
                            />
                          </div>
                          <div class="form-actions">
                            <button
                              type="submit"
                              class="btn-confirm"
                              :disabled="isChangingPassword"
                            >
                              <span v-if="isChangingPassword"
                                >Caricamento...</span
                              >
                              <span v-else>Conferma</span>
                            </button>
                            <button
                              type="button"
                              @click="mostraFormPassword = false"
                              class="btn-cancel"
                            >
                              Annulla
                            </button>
                          </div>
                        </form>
                        <div
                          v-else-if="usesExternalPasswordManager"
                          class="external-password-box"
                        >
                          <i class="fa-solid fa-shield-halved"></i>
                          <div>
                            <h4>Password account</h4>
                            <p>
                              Puoi modificare la password dalla gestione sicura
                              del tuo account.
                            </p>
                            <button
                              type="button"
                              class="btn-confirm account-security-btn"
                              @click="apriGestionePassword"
                            >
                              Gestisci password
                            </button>
                          </div>
                        </div>
                        <div v-else class="external-password-box">
                          <i class="fa-solid fa-circle-info"></i>
                          <div>
                            <h4>Password non disponibile</h4>
                            <p>
                              Questo account non espone un cambio password
                              diretto. Contatta l'amministratore dello studio.
                            </p>
                          </div>
                        </div>
                        <p v-if="passwordMessage" :class="passwordMessageType">
                          {{ passwordMessage }}
                        </p>
                      </div>
                    </transition>
                  </div>
                  <!-- Toggle Elimina Account -->
                  <div class="action-section">
                    <button
                      @click="mostraConfermaDelete = !mostraConfermaDelete"
                      class="btn-toggle delete-btn"
                      :class="{ active: mostraConfermaDelete }"
                    >
                      <i class="fa-solid fa-trash"></i>
                      Elimina Account
                      <span
                        class="arrow"
                        :class="{ open: mostraConfermaDelete }"
                        >▼</span
                      >
                    </button>
                    <transition name="fade-slide">
                      <div
                        v-if="mostraConfermaDelete"
                        class="form-container delete-confirm"
                      >
                        <p class="message-form-delete">
                          Eliminando il tuo account {{ utente.email }} verranno
                          eliminati i dati MyStudio ad esso associati. Gli altri
                          utenti registrati nel tuo studio potranno continuare
                          ad usare i loro account.
                        </p>
                        <div class="form-actions">
                          <button
                            @click="openDeleteModal"
                            class="btn-confirm btn-delete"
                            :disabled="isDeleting"
                          >
                            <span v-if="isDeleting">Eliminazione...</span>
                            <span v-else>Elimina Account</span>
                          </button>
                          <button
                            @click="mostraConfermaDelete = false"
                            class="btn-cancel"
                          >
                            Annulla
                          </button>
                        </div>
                        <p v-if="deleteMessage" :class="deleteMessageType">
                          {{ deleteMessage }}
                        </p>
                      </div>
                    </transition>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </template>

        <template v-else-if="isLoading">
          <div class="personale-skeleton">
            <div class="studio-skeleton personale-dashboard-skeleton">
              <div class="personale-skeleton-header">
                <div class="skeleton personale-skeleton-avatar"></div>
                <div class="personale-skeleton-heading-lines">
                  <div class="skeleton personale-skeleton-title"></div>
                  <div class="skeleton personale-skeleton-email"></div>
                </div>
              </div>

              <div class="personale-skeleton-stats">
                <div
                  v-for="card in 4"
                  :key="`personale-skeleton-stat-${card}`"
                  class="personale-skeleton-stat-card"
                >
                  <div class="skeleton personale-skeleton-stat-label"></div>
                  <div class="skeleton personale-skeleton-stat-value"></div>
                </div>
              </div>

              <div class="skeleton personale-skeleton-action"></div>
            </div>
          </div>
        </template>
      </div>
      <div class="download-log-section">
        <h3
          :title="
            ha(user, 'cronologia_operazioni') ? '' : 'Disponibile da piano Plus'
          "
        >
          Le tue operazioni

          <!-- ICONA INFO solo per chi HA la cronologia (Plus e Premium) -->
          <span
            v-if="ha(user, 'cronologia_operazioni')"
            class="info-icon-operations"
          >
            <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
            <span class="tooltip">
              <template v-if="!ha(user, 'cronologia_illimitata')">
                Cronologia delle ultime 10 operazioni · Piano Plus
              </template>
              <template v-else>
                Cronologia completa di tutte le operazioni · Piano Premium
              </template>
            </span>
          </span>
          <span class="lock-icon">
            <i
              v-if="!ha(user, 'cronologia_operazioni')"
              class="fa-solid fa-lock"
            ></i>
          </span>
          <!-- BADGE INFINITO solo per Premium -->
          <!-- <span
            v-if="ha(user, 'cronologia_illimitata')"
            class="premium-badge"
            title="Cronologia illimitata"
          >
            Illimitata
          </span> -->
        </h3>
        <p v-if="archivedFilesMessage" class="archived-files-message">
          {{ archivedFilesMessage }}
        </p>
        <table class="download-log-table">
          <thead>
            <tr>
              <th>Strumento</th>
              <th>File Caricato</th>
              <th>File Elaborato</th>
              <th>Data Operazione</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading -->
            <template v-if="isLoading">
              <tr v-for="n in 5" :key="n">
                <td><div class="skeleton-cell"></div></td>
                <td><div class="skeleton-cell"></div></td>
                <td><div class="skeleton-cell"></div></td>
                <td><div class="skeleton-cell"></div></td>
              </tr>
            </template>

            <!-- Nessun log -->
            <template v-else-if="!ha(user, 'cronologia_operazioni')">
              <tr>
                <td colspan="4" class="operationtext">
                  Cronologia operazioni disponibile a partire dal piano Plus
                </td>
              </tr>
            </template>
            <template v-else-if="downloadLogs.length === 0">
              <tr>
                <td colspan="4" class="operationtext">
                  Nessuna operazione effettuata finora.
                </td>
              </tr>
            </template>

            <!-- LOG VERO (struttura originale che AMIAMO) -->
            <template v-else>
              <template v-for="log in downloadLogs">
                <tr
                  :key="log.id"
                  :class="{ 'row-expanded': isExpanded(log.id) }"
                >
                  <td>{{ formatOperation(log.operazione) }}</td>
                  <td>
                    <button
                      v-if="hasUploadedArchivedFile(log)"
                      :class="[
                        'archived-file-link',
                        { disabled: !canDownloadArchivedFiles() },
                      ]"
                      @click.stop="downloadUploadedArchivedFile(log)"
                    >
                      {{ getUploadedArchivedFileLabel(log) }}
                    </button>
                    <template v-else>{{ log.file_name }}</template>
                  </td>
                  <td
                    class="processed-files-cell"
                    @click="
                      log.file_scaricati && log.file_scaricati.length > 1
                        ? toggleExpand(log.id)
                        : null
                    "
                    :class="{
                      'clickable-cell':
                        (log.file_scaricati && log.file_scaricati.length > 1) ||
                        hasArchivedFiles(log),
                    }"
                  >
                    <template v-if="Array.isArray(log.file_scaricati)">
                      <template v-if="log.file_scaricati.length === 1">
                        <button
                          v-if="hasArchivedFiles(log)"
                          :class="[
                            'archived-file-link',
                            { disabled: !canDownloadArchivedFiles() },
                          ]"
                          @click.stop="downloadArchivedFile(log, 0)"
                        >
                          {{ getArchivedFileLabel(log, 0) }}
                        </button>
                        <template v-else>
                          {{ log.file_scaricati[0] }}
                        </template>
                      </template>
                      <template v-else-if="log.file_scaricati.length > 1">
                        <span class="chip">
                          📁 {{ log.file_scaricati.length }} file</span
                        >
                      </template>
                      <template v-else>Nessun file scaricato</template>
                    </template>
                    <template v-else>Nessun file scaricato</template>
                  </td>
                  <td>{{ formatDate(log.download_date) }}</td>
                </tr>

                <!-- Riga espansa -->
                <tr
                  v-if="isExpanded(log.id)"
                  :key="'expanded-' + log.id"
                  class="expanded-log-row"
                >
                  <td colspan="4" class="expanded-row">
                    <span class="filescaricatititle">File scaricati:</span>
                    <ul>
                      <li
                        v-for="(file, index) in log.file_scaricati || []"
                        :key="`${log.id}-${file}-${index}`"
                      >
                        <button
                          v-if="hasArchivedFileAt(log, index)"
                          :class="[
                            'archived-file-link',
                            { disabled: !canDownloadArchivedFiles() },
                          ]"
                          @click="downloadArchivedFile(log, index)"
                        >
                          {{ getArchivedFileLabel(log, index) }}
                        </button>
                        <template v-else>{{ file }}</template>
                      </li>
                    </ul>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Modal per conferma finale eliminazione -->
    <div v-if="mostraModalDelete" class="modal-delete">
      <div class="modal-content-delete">
        <p>
          Sei sicuro di voler eliminare il tuo account? Questa azione è
          irreversibile e cancellerà tutti i tuoi dati.
        </p>
        <div class="form-actions">
          <button
            @click="deleteAccount"
            class="btn-confirm btn-delete"
            :disabled="isDeleting"
          >
            <span v-if="isDeleting">Eliminazione...</span>
            <span v-else>Conferma Eliminazione</span>
          </button>
          <button @click="mostraModalDelete = false" class="btn-cancel">
            Annulla
          </button>
        </div>
        <p v-if="deleteMessage" :class="deleteMessageType">
          {{ deleteMessage }}
        </p>
      </div>
    </div>
    <div
      v-if="mostraClerkProfileModal"
      class="clerk-profile-modal"
      @click.self="chiudiGestionePasswordClerk"
    >
      <div class="clerk-profile-modal-content">
        <button
          type="button"
          class="clerk-profile-close"
          @click="chiudiGestionePasswordClerk"
          aria-label="Chiudi gestione account"
        >
          ×
        </button>
        <div ref="clerkUserProfileContainer" class="clerk-profile-host"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js"; // adatta il percorso se serve
import { getClerk } from "@/auth/clerk.js";
import { haFunzionalita as ha } from "@/utils/plans";
import ProgressBar from "../components/ProgressBar.vue";

export default {
  name: "AreaPersonale",
  components: {
    ProgressBar,
  },
  data() {
    return {
      studio: null,
      utente: null,
      isLoading: true,
      downloadLogs: [],
      expandedRows: [],
      tiers: [
        { soglia: 0, feature: "Tema base" },
        { soglia: 100, feature: "Tema chiaro/scuro" },
        { soglia: 250, feature: "Sfondi personalizzati" },
        { soglia: 5000, feature: "Icone e animazioni avanzate" },
      ],
      mostraModificaDati: false, // Nuovo flag per toggle principale
      mostraFormPassword: false,
      mostraFormProfilo: false,
      mostraConfermaDelete: false,
      mostraModalDelete: false,
      form: {
        vecchiaPassword: "",
        nuovaPassword: "",
        confermaPassword: "",
        firstName: "",
        lastName: "",
      },
      isChangingPassword: false,
      passwordMessage: "",
      passwordMessageType: "",
      isUpdatingProfile: false,
      profileMessage: "",
      profileMessageType: "",
      isDeleting: false,
      deleteMessage: "",
      deleteMessageType: "",
      archivedFilesMessage: "",
      archivedFilesMessageTimeout: null,
      mostraClerkProfileModal: false,
    };
  },
  computed: {
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    unlockedFeatures() {
      const crediti = this.utente?.crediti_totali_acquistati || 0;
      return this.tiers
        .filter((t) => crediti >= t.soglia)
        .map((t) => t.feature);
    },
    maxTier() {
      return this.tiers[this.tiers.length - 1].soglia;
    },
    progressPercentage() {
      const crediti = this.utente?.crediti_totali_acquistati || 0;
      const p = (crediti / this.maxTier) * 100;
      return Math.min(100, Math.round(p));
    },
    canChangePasswordInMyStudio() {
      if (typeof this.utente?.can_change_password === "boolean") {
        return this.utente.can_change_password;
      }

      return ["internal_test", "legacy"].includes(
        this.utente?.auth_provider || "legacy"
      );
    },
    usesExternalPasswordManager() {
      if (typeof this.utente?.uses_external_password === "boolean") {
        return this.utente.uses_external_password;
      }

      return ["clerk", "pending_clerk"].includes(
        this.utente?.auth_provider || ""
      );
    },
  },
  mounted() {
    this.fetchUtente();
    this.fetchAllData();
  },
  beforeDestroy() {
    this.unmountClerkUserProfile();
  },
  methods: {
    ha,
    async fetchAllData() {
      this.isLoading = true;
      try {
        // Eseguo entrambe le chiamate in parallelo
        const [studioResponse, logsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/studio/overview`),
          axios.get(`${API_BASE_URL}/utente/download_logs`),
        ]);

        // Gestione risposta studio
        this.studio = studioResponse.data.studio;
        if (this.studio && this.studio.id) {
          console.log("Studio caricato correttamente:", this.studio);
        } else {
          console.warn("Studio non valido o privo di ID.");
        }

        // Gestione risposta log
        if (logsResponse.data.success) {
          this.downloadLogs = logsResponse.data.logs;
        } else {
          this.downloadLogs = [];
          console.warn("Nessun log di download disponibile.");
        }
      } catch (error) {
        console.error("Errore nel caricamento dati:", error);
        // Potresti anche qui resettare o pulire dati in caso di errore
        this.studio = null;
        this.downloadLogs = [];
      } finally {
        this.isLoading = false;
      }
    },
    fetchUtente() {
      axios
        .get(`${API_BASE_URL}/utente/info_personale`)
        .then((response) => {
          this.utente = response.data;
          this.form.firstName = this.utente.first_name || "";
          this.form.lastName = this.utente.last_name || "";
        })
        .catch((error) => {
          console.error("Errore nel recupero delle info utente:", error);
        });
    },
    toggleExpand(id) {
      const index = this.expandedRows.indexOf(id);
      if (index === -1) {
        this.expandedRows.push(id);
      } else {
        this.expandedRows.splice(index, 1);
      }
    },
    isExpanded(id) {
      return this.expandedRows.includes(id);
    },
    hasArchivedFiles(log) {
      return (
        Array.isArray(log?.archived_files) && log.archived_files.length > 0
      );
    },
    hasUploadedArchivedFile(log) {
      return !!log?.uploaded_archived_files?.[0]?.relative_path;
    },
    hasArchivedFileAt(log, index) {
      return !!log?.archived_files?.[index]?.relative_path;
    },
    canDownloadArchivedFiles() {
      return ha(this.user, "archivio_scaricabile_file_convertiti");
    },
    getArchivedFileLabel(log, index) {
      return (
        log?.archived_files?.[index]?.display_name ||
        log?.file_scaricati?.[index] ||
        "Scarica file"
      );
    },
    getUploadedArchivedFileLabel(log) {
      return log?.uploaded_archived_files?.[0]?.display_name || log?.file_name;
    },
    formatOperation(operation) {
      const labels = {
        "Conversione Prospetto Paghe": "Prospetto Paghe",
        "Conversione Modello F24": "Modello F24",
        "Conversione Bilancio Analitico": "Bilancio Analitico",
      };
      return (
        labels[operation] || (operation || "").replace(/^Conversione\s+/, "")
      );
    },
    showArchivedFilesMessage(message) {
      this.archivedFilesMessage =
        message || "Per scaricare i file archiviati serve il piano Premium.";
      clearTimeout(this.archivedFilesMessageTimeout);
      this.archivedFilesMessageTimeout = setTimeout(() => {
        this.archivedFilesMessage = "";
      }, 3000);
    },
    isInlinePreviewable(fileName) {
      const ext = (fileName || "").split(".").pop()?.toLowerCase() || "";
      return [
        "pdf",
        "csv",
        "txt",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "webp",
      ].includes(ext);
    },
    buildArchivedFileUrl(logId, fileIndex, archiveKind, disposition) {
      const params = new URLSearchParams({
        log_id: String(logId),
        file_index: String(fileIndex),
        archive_kind: archiveKind,
        disposition,
      });
      return `${API_BASE_URL}/download_archived_log_file?${params.toString()}`;
    },
    async openOrDownloadArchivedFile({
      log,
      fileIndex,
      archiveKind,
      fileName,
      errorMessage,
    }) {
      if (!this.canDownloadArchivedFiles()) {
        this.showArchivedFilesMessage();
        return;
      }

      const disposition = this.isInlinePreviewable(fileName)
        ? "inline"
        : "attachment";
      const url = this.buildArchivedFileUrl(
        log.id,
        fileIndex,
        archiveKind,
        disposition
      );

      try {
        if (disposition === "inline") {
          window.open(url, "_blank", "noopener");
          return;
        }

        const response = await axios.get(url, { responseType: "blob" });
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Errore apertura/download file archiviato:", error);
        this.showArchivedFilesMessage(errorMessage);
      }
    },
    async downloadArchivedFile(log, index) {
      await this.openOrDownloadArchivedFile({
        log,
        fileIndex: index,
        archiveKind: "converted",
        fileName: this.getArchivedFileLabel(log, index),
        errorMessage:
          "Impossibile aprire o scaricare il file archiviato in questo momento.",
      });
    },
    async downloadUploadedArchivedFile(log) {
      await this.openOrDownloadArchivedFile({
        log,
        fileIndex: 0,
        archiveKind: "uploaded",
        fileName: this.getUploadedArchivedFileLabel(log),
        errorMessage:
          "Impossibile aprire o scaricare il file caricato archiviato in questo momento.",
      });
    },
    apriModificaNome() {
      this.mostraModificaDati = true;
      this.mostraFormProfilo = true;

      // Focus automatico sul campo Nome (opzionale, ma molto utile)
      this.$nextTick(() => {
        const input = this.$el.querySelector('input[placeholder="Nome"]');
        if (input) input.focus();
      });
    },
    async updateProfile() {
      // Reset messaggio
      this.profileMessage = "";
      this.profileMessageType = "";

      // Validazione frontend (opzionale, ad es. per lunghezza minima)
      if (!this.form.firstName.trim() || !this.form.lastName.trim()) {
        this.profileMessage = "Nome e cognome sono obbligatori";
        this.profileMessageType = "error";
        return;
      }

      this.isUpdatingProfile = true;

      try {
        const response = await axios.put(`${API_BASE_URL}/update_profile`, {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
        });

        if (response.data.success) {
          // Aggiorna localStorage
          localStorage.setItem("firstName", this.form.firstName);
          localStorage.setItem("lastName", this.form.lastName);

          // Aggiorna dati utente locale
          this.utente.first_name = this.form.firstName;
          this.utente.last_name = this.form.lastName;
          this.$root.$emit("user-updated");

          this.profileMessage = "Profilo aggiornato con successo!";
          this.profileMessageType = "success";
        }
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          "Errore durante l'aggiornamento profilo";
        this.profileMessage = msg;
        this.profileMessageType = "error";
      } finally {
        this.isUpdatingProfile = false;
      }
    },
    formatDate(isoString) {
      if (!isoString) return "N/D";
      const date = new Date(isoString);
      return date.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    async cambiaPassword() {
      if (!this.canChangePasswordInMyStudio) {
        this.passwordMessage =
          "Per questo account usa la gestione password sicura.";
        this.passwordMessageType = "error";
        return;
      }

      // Reset messaggio
      this.passwordMessage = "";
      this.passwordMessageType = "";

      // Validazione frontend
      if (this.form.nuovaPassword !== this.form.confermaPassword) {
        this.passwordMessage = "Le nuove password non coincidono";
        this.passwordMessageType = "error";
        return;
      }

      if (this.form.nuovaPassword.length < 6) {
        this.passwordMessage =
          "La nuova password deve avere almeno 6 caratteri";
        this.passwordMessageType = "error";
        return;
      }

      this.isChangingPassword = true;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/utente/cambia_password`,
          {
            vecchia_password: this.form.vecchiaPassword,
            nuova_password: this.form.nuovaPassword,
          }
        );

        if (response.data.success) {
          this.passwordMessage = "Password cambiata con successo!";
          this.passwordMessageType = "success";
          // Resetta form
          this.form.vecchiaPassword = "";
          this.form.nuovaPassword = "";
          this.form.confermaPassword = "";
        }
      } catch (error) {
        const msg =
          error.response?.data?.message || "Errore durante il cambio password";
        this.passwordMessage = msg;
        this.passwordMessageType = "error";
      } finally {
        this.isChangingPassword = false;
      }
    },
    async apriGestionePassword() {
      this.passwordMessage = "";
      this.passwordMessageType = "";

      try {
        const clerk = await getClerk();
        if (!clerk.isSignedIn || !clerk.user) {
          this.passwordMessage =
            "Per modificare questa password devi accedere di nuovo con il login sicuro.";
          this.passwordMessageType = "error";
          return;
        }

        if (typeof clerk.openUserProfile === "function") {
          try {
            clerk.openUserProfile();
            return;
          } catch (openError) {
            console.warn("Overlay profilo Clerk non disponibile", openError);
          }
        }

        if (typeof clerk.redirectToUserProfile === "function") {
          try {
            await clerk.redirectToUserProfile();
            return;
          } catch (redirectError) {
            console.warn(
              "Redirect profilo Clerk non disponibile",
              redirectError
            );
          }
        }

        if (typeof clerk.mountUserProfile === "function") {
          await this.apriGestionePasswordClerkInPagina(clerk);
          return;
        }

        this.passwordMessage =
          "Gestione password non disponibile in questo momento. Esci e accedi di nuovo, poi riprova.";
        this.passwordMessageType = "error";
      } catch (error) {
        console.error("Errore apertura gestione password", error);
        this.passwordMessage =
          "Non riesco ad aprire la gestione password. Esci e accedi di nuovo, poi riprova.";
        this.passwordMessageType = "error";
      }
    },
    async apriGestionePasswordClerkInPagina(clerk) {
      this.mostraClerkProfileModal = true;

      await this.$nextTick();

      const container = this.$refs.clerkUserProfileContainer;
      if (!container) {
        throw new Error("Contenitore profilo account non disponibile.");
      }

      clerk.mountUserProfile(container, {
        routing: "hash",
      });
    },
    async unmountClerkUserProfile() {
      try {
        const clerk = await getClerk();
        const container = this.$refs.clerkUserProfileContainer;
        if (container && typeof clerk.unmountUserProfile === "function") {
          clerk.unmountUserProfile(container);
        }
      } catch (error) {
        console.warn("Cleanup profilo Clerk non riuscito", error);
      }
    },
    async chiudiGestionePasswordClerk() {
      await this.unmountClerkUserProfile();
      this.mostraClerkProfileModal = false;
    },
    openDeleteModal() {
      this.mostraModalDelete = true;
    },
    async deleteAccount() {
      this.deleteMessage = "";
      this.deleteMessageType = "";
      this.isDeleting = true;

      try {
        await axios.delete(`${API_BASE_URL}/utente/delete_account`);

        this.deleteMessage =
          "Account eliminato con successo. Verrai reindirizzato.";
        this.deleteMessageType = "success";

        // Pulisci localStorage e reindirizza al login
        localStorage.clear();
        setTimeout(() => {
          this.$router.push("/users-login");
        }, 2000);
      } catch (error) {
        const msg =
          error.response?.data?.error ||
          "Errore durante l'eliminazione dell'account";
        this.deleteMessage = msg;
        this.deleteMessageType = "error";
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-date {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.datetitle {
  /* Stili per il titolo */
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
.lock-icon {
  font-size: 1rem;
  transition: all 0.2s ease;
  margin-left: 5px;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: baseline;
  padding: 1rem 2rem;
  gap: 18px;
}
.container-area-personale {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.main-content {
  align-content: center;
  align-items: center;
}
.title-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.main-container {
  width: 100% !important;
}
.btngotosettings {
  position: absolute;
  right: -32rem;
  top: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #e0e0e0;
  color: #333;
  text-decoration: none;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.2s ease;
  margin-top: 1rem;
}

.btngotosettings:hover {
  background-color: #d5d5d5;
  color: #000;
}

.settingsicon {
  font-size: 1rem;
}
.studio-info-personale {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #2c3e50;
  margin-top: 0;
  width: 100%;
}
.utente-dashboard {
  width: 100%;
  max-width: 60rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem 2rem 2rem 2rem;
}

.utente-title-wrapper {
  display: flex;
  align-items: center; /* allinea icona a metà del blocco nome+email */
  justify-content: flex-start;
  margin-bottom: 2rem;
  margin-left: 0;
  gap: 12px;
  color: #34495e;
  text-align: left;
}

.utente-icon {
  font-size: 2.2rem;
  color: #2c3e50;
}

.utente-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-width: 0;
  text-align: left;
}

.utente-name {
  font-size: 1.3rem;
  margin: 0;
  text-align: left;
}

.utente-email {
  font-size: 0.9rem;
  color: #777;
  margin-top: 2px;
  margin-bottom: 0;
  text-align: left;
}

.todo-highlight {
  color: #665d5d;
  font-size: 1.1rem;
  font-weight: bold;
  background-color: #ffecec;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgb(253, 186, 186);
  display: inline-block;
  transition: all 0.2s ease;
}
.todo-highlight:hover {
  color: #bc3829;
  background-color: #ffecec;
  border: 1px solid rgb(234, 124, 124);
}

.utente-stats {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1 1 20%;
  min-width: 12rem;
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

.stat-label {
  display: block;
  font-weight: 600;
  color: #555;
  margin-bottom: 0.5rem;
}

.stat-value {
  font-size: 1.2rem;
  color: #0dad23;
}

.modifica-dati-section {
  text-align: left;
  margin-top: 1rem;
}

.btn-modifica-dati {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 0.7rem 1.5rem;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-modifica-dati:hover {
  background-color: #f8f8f8;
  color: #064f2a;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-modifica-dati.active {
  background-color: rgb(33, 105, 81);
  color: white;
  border-color: rgb(29, 87, 67);
}

.btn-modifica-dati i {
  font-size: 0.9rem;
}

.sub-actions {
  display: flex;
  justify-content: space-around;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.action-section {
  flex: 1 1 40%;
  min-width: 18rem;
}

.btn-toggle {
  width: 100%;
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  padding: 0.7rem 1rem;
  font-weight: 500;
  color: #0a6e3c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s, color 0.2s;
}

.btn-toggle:hover {
  background-color: #e6f0df;
  color: #064f2a;
}

.btn-toggle.active {
  background-color: rgb(33, 105, 81);
  color: white;
}

.btn-toggle i {
  font-size: 0.9rem;
}

.arrow {
  font-size: 0.7rem;
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

.form-container {
  margin-top: 0.8rem;
  padding: 0.8rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.external-password-box {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 0.95rem;
  border: 1px solid #cfe1d6;
  border-radius: 10px;
  background: #f4fbf6;
  color: #24543d;
  text-align: left;
}

.external-password-box > i {
  margin-top: 0.18rem;
  color: #14532d;
  font-size: 1.15rem;
}

.external-password-box h4 {
  margin: 0 0 0.3rem;
  color: #0f5132;
}

.external-password-box p {
  margin: 0 0 0.8rem;
  line-height: 1.4;
}

.account-security-btn {
  width: auto;
  min-width: 11rem;
}

.clerk-profile-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(4, 32, 22, 0.45);
}

.clerk-profile-modal-content {
  position: relative;
  width: min(62rem, 100%);
  max-height: min(46rem, 92vh);
  overflow: auto;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
}

.clerk-profile-close {
  position: absolute;
  top: 0.75rem;
  right: 0.85rem;
  z-index: 2;
  width: 2.2rem;
  height: 2.2rem;
  border: 0;
  border-radius: 999px;
  background: #eef5f0;
  color: #0f5132;
  font-size: 1.45rem;
  line-height: 1;
  cursor: pointer;
}

.clerk-profile-host {
  min-height: 34rem;
  padding: 1.5rem;
}

.action-form {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.input-group {
  display: flex;
  flex-direction: column;
}

.action-input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

.action-input:focus {
  outline: none;
  border-color: #0dad23;
  box-shadow: 0 0 0 2px rgba(13, 173, 35, 0.1);
}

.form-actions {
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  margin-top: 0.5rem;
}

.btn-confirm {
  background-color: #0dad23;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-confirm:hover:not(:disabled) {
  background-color: #0a8a1c;
}

.btn-confirm:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-cancel {
  background-color: #eee;
  color: #555;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cancel:hover {
  background-color: #ddd;
}

.success {
  color: #0dad23;
  text-align: center;
  font-weight: 500;
  font-size: 0.9rem;
}

.error {
  color: #e74c3c;
  text-align: center;
  font-weight: 500;
  font-size: 0.9rem;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.download-log-section {
  margin-top: 1.5rem;
  margin-bottom: 4rem;
  padding: 0.5rem;
  padding-bottom: 3rem;
  width: 100%;
  max-width: 60rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 2rem 2rem 2rem;
}

.download-log-section h3 {
  margin-bottom: 1.5rem;
  gap: 6px;
  padding-top: 0.5rem;
  font-size: 1.2rem;
  color: #333;
  display: inline-flex;
  align-items: center;
}
.info-icon-operations {
  width: 14px;
  height: 14px;
  text-align: center;
  font-size: 12px;
  color: #555;
  border: 1px solid #555;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  line-height: 14px;
  font-weight: normal !important;
}
.info-icon-operations:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.download-log-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.download-log-table thead {
  background-color: #f0f0f0;
}
.download-log-table th {
  text-align: center !important;
}
.download-log-table th,
.download-log-table td {
  padding: 0.75rem;
  border: 1px solid #ddd;
  text-align: left;
  overflow-wrap: break-word;
}
.download-log-table th:nth-child(1),
.download-log-table td:nth-child(1) {
  width: 25%; /* ad esempio, la prima colonna più larga */
}
.download-log-table th:nth-child(1),
.download-log-table td:nth-child(1) {
  text-align: center;
}
.download-log-table th:nth-child(2),
.download-log-table td:nth-child(2) {
  width: 25%; /* ad esempio, la prima colonna più larga */
}
.download-log-table th:nth-child(3),
.download-log-table td:nth-child(3) {
  width: 34%; /* ad esempio, la prima colonna più larga */
}
.download-log-table tbody .processed-files-cell,
.download-log-table tbody .processed-files-cell .archived-file-link,
.download-log-table tbody .processed-files-cell .chip {
  text-align: left !important;
}
.download-log-table th:nth-child(4),
.download-log-table td:nth-child(4) {
  width: 16%;
  text-align: center;
}
.download-log-table tbody tr {
  transition: background-color 0.2s ease;
}
.download-log-table tbody tr.row-expanded,
.download-log-table tbody tr:hover:not(.expanded-log-row) {
  background-color: #e8e7e7 !important;
}
.operationtext {
  text-align: center !important;
  font-style: italic;
  color: #666;
  height: 2rem;
}
.filescaricatititle {
  display: block;
  margin: 0;
  text-align: left;
}
.expanded-row {
  padding-top: 1em !important;
  text-align: left !important;
}
.expanded-row ul {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
  text-align: left;
}
.expanded-row li,
.expanded-row .archived-file-link {
  text-align: left;
}
.chip {
  display: inline-block;
  background-color: #eef1f5;
  padding: 4px 8px;
  border-radius: 12px;
  color: #333;
  transition: background-color 0.2s ease;
}
.chip:hover {
  background-color: #dbe5f0;
}
.clickable-cell {
  cursor: pointer;
  color: #0056b3;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.personale-skeleton {
  width: 100%;
  max-width: 60rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.studio-skeleton {
  box-sizing: border-box;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  width: min(100%, 60rem) !important;
  min-height: 16.75rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.personale-dashboard-skeleton {
  margin-top: 0;
}

.personale-skeleton-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 1rem;
}

.personale-skeleton-avatar {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  flex: 0 0 2.2rem;
}

.personale-skeleton-heading-lines {
  width: min(24rem, 70%);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.personale-skeleton-title {
  width: 60%;
  height: 1.3rem;
}

.personale-skeleton-email {
  width: 82%;
  height: 0.9rem;
}

.personale-skeleton-stats {
  display: flex;
  gap: 1rem;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
}

.personale-skeleton-stat-card {
  box-sizing: border-box;
  flex: 1 1 20%;
  min-width: 12rem;
  padding: 1rem;
  border-radius: 6px;
  background-color: #f9f9f9;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.personale-skeleton-stat-label {
  width: 82%;
  height: 0.95rem;
  margin: 0 auto 0.8rem;
}

.personale-skeleton-stat-value {
  width: 38%;
  height: 1.2rem;
  margin: 0 auto;
}

.personale-skeleton-action {
  width: 13.5rem;
  height: 2.65rem;
  border-radius: 20px;
}

@media (max-width: 720px) {
  .studio-skeleton {
    padding: 1.25rem;
  }

  .personale-skeleton-header {
    margin-left: 0;
  }

  .personale-skeleton-heading-lines {
    width: 100%;
  }

  .personale-skeleton-stat-card {
    flex-basis: 100%;
  }
}

.skeleton {
  background-color: #e0e0e0;
  height: 20px;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton.title {
  width: 60%;
  height: 24px;
  align-self: flex-start; /* allinea a sinistra */
}

.skeleton.row {
  width: 20rem;
  align-self: flex-start;
}

.skeleton.row.short {
  width: 40%;
  align-self: flex-start;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.skeleton-cell {
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
  width: 100%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.form-container {
  height: 12rem;
}
.progressbar {
  display: none;
}
.btn-toggle.delete-btn {
  color: #7f7f7f;
}

.btn-toggle.delete-btn:hover {
  background-color: #e4e4e4;
  color: #808080;
}

.btn-toggle.delete-btn.active {
  background-color: #ffdddd;
  color: #6d6d6d;
}

.delete-confirm {
  text-align: center;
}
.message-form-delete {
  text-align: left;
  padding: 0.5rem 1rem;
}
.btn-delete {
  background-color: #e74c3c;
}

.btn-delete:hover:not(:disabled) {
  background-color: #c0392b;
}

/* Stili per il modal di conferma finale */
.modal-delete {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content-delete {
  background: white;
  padding: 2.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 80%;
}

.modal-content-delete p {
  margin-bottom: 1.5rem;
}

.archived-file-link {
  border: 0;
  background: transparent;
  color: #1d4ed8;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
}

.archived-file-link.disabled {
  color: #7b8794;
  cursor: not-allowed;
  text-decoration: none;
}

.archived-files-message {
  margin: 0 0 0.8rem;
  color: #7c5c00;
  font-size: 0.95rem;
}
</style>
